module.exports = __webpack_public_path__ + "img/artists-carrousel-2.a5b2088b.png";